import { jsonProperty, Serializable } from 'ts-serializable';

export class RefreshTokenModel extends Serializable {
  @jsonProperty(String, null) token: string | null = null;
  @jsonProperty(String, null) refreshToken: string | null = null;
}
